import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { decryptData } from "../../../crypto";
import useHeaderStyles from "../testStyle/gateStyle/headerStyle";
import { ReactComponent as InfoIcon } from "../../../images/Info.svg";
import { ReactComponent as Question } from "../../../images/Question.svg";
import QuestionPaper from "./QuestionPaper";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { useLanguages } from "../../../context/LanguagesContext";
// import HoverInfo from "./hoverInfo";

const Header = ({children,activeSubjectId}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openInstructions, setOpenInstructions] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(false);
  const classes = useHeaderStyles();

  const { languages, handleChange, selectedLanguage } = useLanguages();

  const handleOpenInstructions = () => {
    setOpenInstructions(true);
  };

  const handleCloseInstructions = () => {
    setOpenInstructions(false);
  };
  const handleOpenQuestion = () => {
    setOpenQuestion(true);
  };

  const handleCloseQuestion = () => {
    setOpenQuestion(false);
  };

  const examInstructions =
    sessionStorage.getItem("examInstructions") ||
    "No instructions available. Please check with your exam administrator.";

  return (
    <div className={classes.headerContainer}>
      {/* Top Blue Bar */}
      {/* <AppBar position="static" className={classes.topBlueBar}>
        <Toolbar className={classes.toolbarCenter}>
          <Typography className={classes.clientLogoText}>
            CLIENT LOGO
          </Typography>
        </Toolbar>
      </AppBar> */}

      {/* Black Bar */}
      <Box className={classes.blackBar}>
        <div className={classes.blackBarContainer}>
          {/* Left text */}
          <Typography variant="subtitle1" className={classes.examTitle}>
            {decryptData(sessionStorage.getItem("exam_name"))}
          </Typography>

          {/* Right icons */}
          <Box
            className={`${classes.iconsContainer} ${
              isMobile ? classes.mobileMarginTop : ""
            }`}
          >
            <Box className={classes.iconTextGroup}>
              {/* <Question  />
              <Typography variant="body2">Question paper</Typography> */}
              <Select
                value={selectedLanguage}
                onChange={handleChange}
                size="small"
                // className={classes.select}
                style={{background:'white',height:'30px'}}
              >
                {languages?.map((l, i) => (
                  <MenuItem key={i} value={l.value}>
                    {l.label}
                  </MenuItem>
                ))}

                {/* <MenuItem value="Hindi">Hindi</MenuItem> */}
              </Select>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
              onClick={handleOpenInstructions}
            >
              <InfoIcon />
              <Typography variant="body2">Instruction</Typography>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
              onClick={handleOpenQuestion}
            >
              <Question />
              <Typography variant="body2">Question Paper</Typography>
            </Box>
            <Box
              className={`${classes.iconTextGroup} ${classes.instructionsIcon}`}
              // onClick={handleOpenQuestion}
            >
           
            {children}
            </Box>
          </Box>
        </div>
      </Box>

      {/* Instructions Dialog */}
      <Dialog
        open={openInstructions}
        onClose={handleCloseInstructions}
        maxWidth={false}
        PaperProps={{
          style: {
            width: "80vw",
            height: "80vh",
            // maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1374aa",
            p: 0, // removes default padding
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              color: "white",
            }}
          >
            <span>Exam Instructions</span>
            <IconButton onClick={handleCloseInstructions} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <DialogContentText className={classes.instructionsDialogContent}>
            <div
              dangerouslySetInnerHTML={{
                __html: decryptData(examInstructions),
              }}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openQuestion}
        onClose={handleCloseQuestion}
        maxWidth={false}
        PaperProps={{
          style: {
            width: "80vw",
            height: "80vh",
            // maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1374aa",
            p: 0, // removes default padding
            overflow: "hidden",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "16px",
              paddingRight: "16px",
              color: "white",
            }}
          >
            <span>Question Paper</span>
            <IconButton onClick={handleCloseQuestion} edge="end">
              <CloseIcon style={{ color: "white" }} />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            overflowX: "hidden",
          }}
        >
          <DialogContentText className={classes.instructionsDialogContent}>
            <QuestionPaper  activeSubjectId={activeSubjectId}/>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Header;
